import api from '../api-methods'

const proxyHr = process.env.VUE_APP_ENV === 'local' ? '/proxy_hr' : process.env.VUE_APP_API_HR
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyMl = process.env.VUE_APP_ENV === 'local' ? '/proxy_ai' : process.env.VUE_APP_ML

const hr = {
	// 获取推荐职位
	getInternalList: payload => {
		return api.get(proxyHr + '/v1/jobs/cvs_jobs_recommend', payload)
	},
	// 获取推荐职位详情
	getRecommendJobDetail: (token, payload = {}) => {
		return api.get(proxyHr + `/v1/jobs/${ token }`, payload)
	},
	//  操作职位时给hr库记录一下
	jobsOperation: payload => {
		return api.get(proxyHr + '/v1/jobs/jobs_operation', payload)
	},
	// 搜索职位
	getJobListBySearch: payload => {
		// return api.post(proxyHr + '/v2/jobs/company_list_unlogin', payload)
		return api.get(proxyHr + '/v2/jobs/company_list_unlogin', payload)
	},
	// query职位搜索
	getJobListByQuerySearch: payload => {
		return api.post(proxyHr + '/v3/jobs/company_list_unlogin', payload)
	},
	// query解析
	querySearch: payload => {
		return api.post(proxyMl + `/v2/parser/queries/jobs`, payload)
	},
	// 职位详情猜你喜欢
	getDetailJobsList: payload => {
		return api.get(proxyHr + '/v1/jobs/recommended_jobs', payload)
	},
	// 相似职位
	getJobToJob: payload => {
		return api.get(proxyHr + '/v1/jobs/job_to_job', payload)
	},
	// 通过简历推荐职位
	getJobByCv: payload => {
		return api.get(proxyHr + `/v1/jobs/cv_to_job`, payload)
	},
	// 一键投递
	oneKeyDeliver: payload => {
		return api.post(proxyApi + '/v3/jobs/bulk_delivery', payload)
	},
	// 获取热门职位
	getObtainCity: payload => {
		return api.get(proxyHr + `/v2/jobs/hot_cities`, payload)
	},
	// 基于在线简历内的求职信息或求职意向推荐职位
	getIntentionToJob: payload => {
		return api.get(proxyHr + `/v1/jobs/intention_to_job`, payload)
	},
  getCompanyJobs: payload => {
		return api.post(proxyHr + `/v3/aggregation/jobs/search`, payload)
	},
}

export default hr
